import request from '../request';
// 获取gio_data
export const gio_data = token => {
  return request({
    url: `/v3/cv_accounts/${token}/gio_data`,
    method: 'get',
    params:{},
  })
}